import styled from 'styled-components';

export const List = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const Toolbar = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
  justify-content: space-between;
`;

export const Count = styled.span`
  font-size: 12px;
  color: #595959;
`;

export const Cards = styled.ul`
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 0;
  margin: 0;
`;

export const Day = styled.section`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const DayLabel = styled.h2`
  margin: 0;
  font-size: 12px;
  font-weight: 700;
  color: #595959;
`;

export const EndOfList = styled.div`
  min-height: 1px;
`;
